import React, { useEffect } from "react";
import { matchPath, Redirect, Route, Switch } from "react-router";

import LoginPage from "./pages/LoginPage";
import RegisterPage from "./pages/RegisterPage";
import PasswordReminderPage from "./pages/PasswordReminderPage";
import DashboardPage from "./pages/DashboardPage";
import SettingsPage from "./pages/SettingsPage";
import PasswordResetPage from "./pages/PasswordResetPage";
import IntegrationsPage from "./pages/IntegrationsPage";
import SyncHistoryPage from "./pages/SyncHistoryPage";
import DomainsPage from "./pages/DomainsPage";
import CalendarsPage from "./pages/CalendarsPage";
import PlansPage from "./pages/PlansPage";
import BillingPage from "./pages/BillingPage";
import ChangePlanPage from "./pages/ChangePlanPage";
import NewCalendarPage from "./pages/NewCalendarPage";
import CalendarPage from "./pages/CalendarPage";
import UsersPage from "./pages/UsersPage";
import PayoutsPage from "./pages/PayoutsPage";
import AttachIntegrationPage from "./pages/AttachIntegrationPage";
import AccountVerificationPage from "./pages/AccountVerificationPage";
import SelectIntegrationPage from "./pages/SelectIntegrationPage";
import QueueWorkersPage from "./pages/QueueWorkersPage";
import QueuedSyncJobs from "./pages/QueuedSyncJobs";
import NewAlertPage from "./pages/NewAlertPage";
import AlertsPage from "./pages/AlertsPage";
import AlertPage from "./pages/AlertPage";
import AttachAlertIntegrationPage from "./pages/AttachAlertIntegrationPage";
import IntegrationAccessCheckPage from "./pages/IntegrationAccessCheckPage";
import IntegrationConnectPage from "./pages/IntegrationConnectPage";
import IntegrationConnectCalendarsPage from "./pages/IntegrationConnectCalendarsPage";
import OrganizationsPage from "./pages/OrganizationsPage";
import appConfig from "../../appConfig";
import OrganizationMembersPage from "./pages/OrganizationMembersPage";
import OrganizationSettingsPage from "./pages/OrganizationSettingsPage";
import InvitationVerificationPage from "./pages/InvitationVerificationPage";
import QueuedWebhookJobs from "./pages/QueuedWebhookJobs";
import OrganizationBrandingPage from "./pages/OrganizationBrandingPage";
// import AffiliatesPage from "./pages/AffiliatesPage";
import PluginsAuthPage from "./pages/plugins/PluginsAuthPage";
import QueuedICSUpdatePage from "./pages/QueuedICSUpdatePage";
import QueuedICSCleanPage from "./pages/QueuedICSCleanPage";
import PluginsDiscardTokenPage from "./pages/plugins/PluginsDiscardTokenPage";
import MailchimpInstructionsPage from "./pages/MailchimpInstructionsPage";
import VerifyEmailPage from "./pages/VerifyEmailPage";
import ThemeDemo from "./theme/untitled/Demo/ThemeDemo";
import ShellDemo from "./templates/AppShell/Demo/ShellDemo";
import OnboardingPage from "./pages/onboarding";
import EmailJobs from "./pages/QueuedEmailJobs";
import RedirectPage from "./pages/RedirectPage";
import OrganizationCustomDomainPage from "./pages/OrgSettings/CustomDomainPage";
import PlanUsagePage from "./pages/Reports/PlanUsage";
import EventEngagementPage from "./pages/Reports/EventEngagement";
let previousMainComponentLocation = null;

const shouldAvoidRender = (oldProps, newProps) => {
  // console.log(
  //   "shouldAvoidRender",
  //   previousMainComponentLocation.pathname,
  //   window.location.pathname
  // );
  if (
    !previousMainComponentLocation ||
    previousMainComponentLocation.pathname.localeCompare(
      window.location.pathname
    ) !== 0
  ) {
    // if next location is one of the modals with static path
    const modalLinkIndex = oldProps.modalLinks.findIndex((modalLink) => {
      const match = matchPath(window.location.pathname, {
        path: modalLink,
        exact: true,
        strict: false,
      });
      return match !== null;
    });

    // console.log("modalLinkIndex", modalLinkIndex);
    // don't update, it's a modal opened
    if (modalLinkIndex >= 0) {
      // console.log("don't update, it's a modal opened");
      return true;
    } else if (
      // don't update, locations are the same
      previousMainComponentLocation &&
      previousMainComponentLocation.pathname.localeCompare(
        window.location.pathname
      ) === 0
    ) {
      // console.log("locations are the same, don't update");
      return true;
    } else {
      // update, locations are different
      /*console.log(
        "update, locations are different",
        previousMainComponentLocation
          ? previousMainComponentLocation.pathname
          : null,
        window.location.pathname
      );*/
      previousMainComponentLocation = { ...window.location };
      return false;
    }
  } else {
    // user switched between sessions on the same path
    if (oldProps.user !== newProps.user) {
      return false;
    }

    // if user is logged in, update
    if (!oldProps.user.model && newProps.user.model) {
      // console.log("update, user is logged in");
      return false;
    }

    // don't update, locations are the same
    // console.log("don't update, locations are the same");
    return true;
  }
};

const MainRoutesComponent = React.memo(
  (props) => {
    // console.log("MainRoutesComponent", props);
    useEffect(() => {
      previousMainComponentLocation = props.location;
    }, []);

    const isAdmin = props.user.model && props.user.model.role === "admins";
    //console.log("FULL RERENDER", isAdmin, props.location.pathname);
    return (
      <React.Fragment>
        <Switch>
          <Route path={"/onboarding"} component={OnboardingPage} />
          <Route exact path="/login" component={LoginPage} />
          <Route exact path="/register" component={RegisterPage} />
          <Route
            path="/account-verification"
            component={AccountVerificationPage}
          />
          <Route exact path="/verify-email" component={VerifyEmailPage} />
          <Route exact path="/logout" component={LoginPage} />
          <Route exact path="/theme-demo" component={ThemeDemo} />
          <Route exact path="/shell-demo" component={ShellDemo} />
          <Route
            exact
            path="/password-reminder"
            component={PasswordReminderPage}
          />
          <Route
            exact
            path="/select-integration"
            component={SelectIntegrationPage}
          />
          <Route
            exact
            path="/accept_invitation/:email/:invitationHash"
            component={InvitationVerificationPage}
          />
          <Route
            path="/password-reset/:email/:token"
            component={PasswordResetPage}
          />

          {/*          <Route
            path="/"
            component={
              props.user.model
                ? props.user.model.is_account_verified
                  ? DashboardPage
                  : VerifyEmailPage
                : LoginPage
            }
          />*/}

          {props.user.model ? (
            <Switch>
              <Route exact path="/dashboard" component={DashboardPage} />
              <Route exact path="/settings" component={SettingsPage} />
              <Route
                exact
                path="/organization-settings"
                component={OrganizationSettingsPage}
              />
              <Route
                exact
                path="/organization-settings/branding"
                component={OrganizationBrandingPage}
              />
              {/* /custom-domain redirects rather than duplicating the route —
                  useDNSProblemAlert and others still link to it, but landing
                  on the canonical nested path is what makes SettingsTabs
                  highlight "Domain & links" as current. */}
              <Redirect exact from="/custom-domain" to="/organization-settings/domain" />
              <Route
                exact
                path="/organization-settings/domain"
                component={OrganizationCustomDomainPage}
              />
              <Route exact path="/integrations" component={IntegrationsPage} />
              <Route
                exact
                path="/integrations/syncs"
                component={SyncHistoryPage}
              />
              <Route
                exact
                path="/integrations/check-access/:type/:uuid"
                component={IntegrationAccessCheckPage}
              />
              <Route
                exact
                path="/integrations/connect/:provider"
                component={IntegrationConnectPage}
              />
              <Route
                exact
                path="/integrations/connect/:provider/calendars"
                component={IntegrationConnectCalendarsPage}
              />
              <Route exact path="/domains" component={DomainsPage} />
              <Route exact path="/calendars" component={CalendarsPage} />
              <Route exact path="/alerts" component={AlertsPage} />
              {/* /billing redirects rather than duplicating the route — ~20
                  upgrade/quota prompts across the app still link to it, but
                  landing on the canonical nested path is what makes
                  SettingsTabs highlight "Billing" as current. */}
              <Redirect exact from="/billing" to="/organization-settings/billing" />
              <Route
                exact
                path="/organization-settings/billing"
                component={BillingPage}
              />
              <Route
                exact
                path="/organization-settings/billing/plans"
                component={ChangePlanPage}
              />
              <Route exact path="/calendar/new" component={NewCalendarPage} />
              <Route exact path="/alert/new" component={NewAlertPage} />
              <Route path="/calendar/:uuid" component={CalendarPage} />
              <Route exact path="/alert/:uuid" component={AlertPage} />
              <Route
                exact
                path="/mailchimp-instructions"
                component={MailchimpInstructionsPage}
              />
              <Route
                path="/attach-integration/:uuid"
                component={AttachIntegrationPage}
              />

              <Route
                exact
                path="/alert/attach-integration/:uuid"
                component={AttachAlertIntegrationPage}
              />

              <Route
                exact
                path={"/organization-settings/members"}
                component={OrganizationMembersPage}
              />
              <Route exact path={"/plugins/auth"} component={PluginsAuthPage} />
              <Route
                exact
                path={"/plugins/discard-token"}
                component={PluginsDiscardTokenPage}
              />
              <Route exact path="/pricing" component={PlansPage} />
              {/* <Route
                exact
                path="/settings/affiliates"
                component={AffiliatesPage}
              /> */}

              <Route
                exact
                path="/reports/event-engagement"
                component={EventEngagementPage}
              />
              <Route
                exact
                path="/reports/plan-usage"
                component={PlanUsagePage}
              />

              {isAdmin && <Route path="/users/:page?" component={UsersPage} />}
              {isAdmin && (
                <Route
                  path={`/${appConfig.links.organizations}/:page?`}
                  component={OrganizationsPage}
                />
              )}

              {isAdmin && (
                <Route path="/accounts/:year" component={PayoutsPage} />
              )}
              {isAdmin && (
                <Route
                  exact
                  path="/queue-workers"
                  component={QueueWorkersPage}
                />
              )}
              {isAdmin && (
                <Route
                  exact
                  path="/sync-jobs/:page?"
                  component={QueuedSyncJobs}
                />
              )}
              {isAdmin && (
                <Route
                  exact
                  path="/webhook-jobs/:page?"
                  component={QueuedWebhookJobs}
                />
              )}
              {isAdmin && (
                <Route exact path="/email-jobs/:page?" component={EmailJobs} />
              )}
              {isAdmin && (
                <Route
                  exact
                  path="/ics-update-jobs/:page?"
                  component={QueuedICSUpdatePage}
                />
              )}
              {isAdmin && (
                <Route
                  exact
                  path="/ics-clean-jobs/:page?"
                  component={QueuedICSCleanPage}
                />
              )}
            </Switch>
          ) : null}
          {/*<Route component={props.user.model ? LoginPage : PageTemplate} />*/}
        </Switch>
        <Route path="/" component={RedirectPage} />
      </React.Fragment>
    );
  },
  (oldProps, nextProps) => {
    const _shouldAvoidRender = shouldAvoidRender(oldProps, nextProps);
    // console.log("MainRoutesComponent _shouldAvoidRender", _shouldAvoidRender);
    return _shouldAvoidRender;
  }
);

export default MainRoutesComponent;
